import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    const tumBlue = "#0066B1";
    const tumBlueDark = "#004C87";

    return (
        <div
            style={{
                minHeight: "100vh",
                background:
                    "radial-gradient(ellipse at center, #0b0c0f 0%, #1a1a1a 80%), linear-gradient(135deg, #0a132d 0%, #121f4c 100%)",
                color: "#eee",
                fontFamily: "'Montserrat', sans-serif",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Slight vignette overlay for mystery */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    pointerEvents: "none",
                    background:
                        "radial-gradient(ellipse at center, transparent 60%, rgba(0,0,0,0.85) 100%)",
                    zIndex: 0,
                }}
            ></div>

            {/* Game title */}
            <h1
                style={{
                    fontFamily: "'Crimson Text', serif",
                    fontSize: "5rem",
                    marginBottom: "0.4rem",
                    color: tumBlue,
                    letterSpacing: "0.15em",
                    textShadow: `
            0 0 8px ${tumBlue}, 
            0 0 20px ${tumBlue}, 
            0 0 30px ${tumBlueDark}, 
            0 0 40px ${tumBlueDark}
          `,
                    position: "relative",
                    zIndex: 1,
                    userSelect: "none",
                    borderBottom: "3px solid transparent",
                    animation: "scannerLine 3s infinite",
                }}
            >
                KIminalfall@TUM
            </h1>

            {/* Subtitle / tagline */}
            <p
                style={{
                    maxWidth: 600,
                    fontSize: "1.6rem",
                    fontWeight: "500",
                    color: "#aaa",
                    marginBottom: "3.5rem",
                    fontStyle: "italic",
                    textShadow: "0 0 6px rgba(0,0,0,0.9)",
                    zIndex: 1,
                    userSelect: "none",
                }}
            >
                Komm und erlebe die spannenden Kriminalfälle an der TUM
            </p>

            {/* Buttons container */}
            <div
                style={{
                    display: "flex",
                    gap: "2rem",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: 320,
                    zIndex: 1,
                }}
            >
                <button
                    onClick={() => navigate("/login")}
                    style={{
                        flex: 1,
                        padding: "1.1rem 0",
                        fontSize: "1.3rem",
                        fontWeight: "700",
                        borderRadius: "9999px",
                        border: "none",
                        backgroundColor: tumBlue,
                        color: "#fff",
                        cursor: "pointer",
                        boxShadow: `
              0 0 12px ${tumBlue}, 
              0 0 30px ${tumBlue}, 
              0 0 40px ${tumBlueDark}
            `,
                        transition: "all 0.25s ease-in-out",
                        userSelect: "none",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = tumBlueDark;
                        e.currentTarget.style.boxShadow = `0 0 20px ${tumBlueDark}, 0 0 40px ${tumBlue}`;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = tumBlue;
                        e.currentTarget.style.boxShadow = `
              0 0 12px ${tumBlue}, 
              0 0 30px ${tumBlue}, 
              0 0 40px ${tumBlueDark}
            `;
                    }}
                >
                    Login
                </button>

                <button
                    onClick={() => navigate("/register")}
                    style={{
                        flex: 1,
                        padding: "1.1rem 0",
                        fontSize: "1.3rem",
                        fontWeight: "700",
                        borderRadius: "9999px",
                        border: `2px solid ${tumBlue}`,
                        backgroundColor: "transparent",
                        color: tumBlue,
                        cursor: "pointer",
                        boxShadow: `0 0 10px rgba(0, 102, 177, 0.6)`,
                        transition: "all 0.25s ease-in-out",
                        userSelect: "none",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = tumBlue;
                        e.currentTarget.style.color = "#fff";
                        e.currentTarget.style.boxShadow = `0 0 20px ${tumBlue}, 0 0 40px ${tumBlueDark}`;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = tumBlue;
                        e.currentTarget.style.boxShadow = `0 0 10px rgba(0, 102, 177, 0.6)`;
                    }}
                >
                    Register
                </button>
            </div>

            {/* Footer tagline */}
            <p
                style={{
                    marginTop: "5rem",
                    fontSize: "1.1rem",
                    color: "#555",
                    fontStyle: "italic",
                    fontFamily: "'Courier New', Courier, monospace",
                    textShadow: "0 0 6px rgba(0,0,0,0.7)",
                    userSelect: "none",
                    letterSpacing: "0.07em",
                    zIndex: 1,
                }}
            >
                Dein Abenteuer beginnt hier...
            </p>

            {/* Keyframe animation in JSX style */}
            <style>
                {`
          @keyframes scannerLine {
            0%, 100% {
              border-color: transparent;
              box-shadow: none;
            }
            50% {
              border-color: ${tumBlue};
              box-shadow: 0 0 12px ${tumBlue};
            }
          }
        `}
            </style>
        </div>
    );
};

export default Home;
